import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.expert.programs');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const WizRoute: any;

@Component({
    selector: 'wiz-page-expert-programs',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.expert.programs/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageExpertProgramsComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public loading: boolean = true;
    public programs: any[] = [];
    public menu: string = 'ongoing';
    public menus: any[] = [
        { key: 'ongoing', label: '진행중 평가/멘토링' },
        { key: 'completed', label: '종료된 평가/멘토링' },
    ];

    public async ngOnInit() {
        await this.service.init();
        this.menu = this.normalizeMenu(WizRoute.segment?.menu);
        await this.load();
    }

    private async load() {
        this.loading = true;
        await this.service.render();
        try {
            const res = await wiz.call("list_programs");
            if (res.code === 200) {
                this.programs = res.data.rows || [];
            } else {
                this.service.alert.show({ title: '오류', message: res.data?.message || '평가 가능한 사업을 불러올 수 없습니다' });
            }
        } catch (e: any) {
            this.service.alert.show({ title: '오류', message: e?.message || String(e) });
        }
        this.loading = false;
        await this.service.render();
    }

    public open(p: any) {
        this.service.href(`/expert/program/${p.id}`);
    }

    public async setMenu(menu: string) {
        this.menu = this.normalizeMenu(menu);
        this.service.href(`/expert/programs/${this.menu}`);
        await this.service.render();
    }

    private normalizeMenu(menu: string): string {
        return menu === 'completed' || menu === 'closed' || menu === 'done' ? 'completed' : 'ongoing';
    }

    public programState(p: any): string {
        return p?.eval_state === 'completed' ? 'completed' : 'ongoing';
    }

    public filteredPrograms(): any[] {
        return (this.programs || []).filter((p: any) => this.programState(p) === this.menu);
    }

    public menuCount(menu: string): number {
        const key = this.normalizeMenu(menu);
        return (this.programs || []).filter((p: any) => this.programState(p) === key).length;
    }

    public emptyMessage(): string {
        return this.menu === 'completed' ? '종료된 평가/멘토링이 없습니다.' : '진행중인 평가/멘토링이 없습니다.';
    }

    public statusLabel(s: string): string {
        const map: any = { 'open': '모집중', 'closed': '마감', 'evaluating': '평가중', 'done': '완료', 'draft': '준비중' };
        return map[s] || s || '';
    }

    public programDisplayTitle(p: any): string {
        return p?.display_title || p?.title || p?.program_title || '-';
    }
}

export default PageExpertProgramsComponent;